export enum LicenseTabControl {
    OVERVIEW = 'OVERVIEW',
    MANAGEMENT = 'MANAGEMENT',
    SUBSCRIPTION = 'SUBSCRIPTION',
    PURCHASE = 'PURCHASE'
};